import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import App from './App';
import { Provider } from 'react-redux';
import store from './reduxcomp/store';
import { StockProvider } from "./contexts/stockContexts";
import { AnalyticsProvider } from "./contexts/AnalyticsContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <React.StrictMode>
    <Provider store={store}>
      <StockProvider>
        <AnalyticsProvider>
          <App />
        </AnalyticsProvider>
      </StockProvider>
    </Provider>
  </React.StrictMode>
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

